module.exports = __webpack_public_path__ + "static/4-fb4a06f24758d1fdb8adde88a5a63d5f.png";